export default __webpack_public_path__ + "static/media/Catamaran-Light.5bc8129b.ttf";